module.exports = __webpack_public_path__ + "static/media/Expand_Histogram_icon.9ce0fb77.svg";